export class WidgetIdList {
  widgetIds: number[] = [];
}
